"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _UTTouchableWithoutFeedback = _interopRequireDefault(require("../UTTouchableWithoutFeedback"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _UTCardFooter = _interopRequireDefault(require("./components/UTCardFooter"));

var _types = require("./types");

var _theme = require("./theme");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTCard = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTCard, _PureComponent);

  function UTCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expandIsSelected: false,
      childrenRef: null,
      childrenHeight: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPress", function (event) {
      event.stopPropagation();
      if (_this.props.onClick) _this.props.onClick();
      return _this.props.isOpen !== null && _this.setState(function (prevState) {
        return {
          expandIsSelected: !prevState.expandIsSelected
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      if (_this.state.childrenRef) _this.setChildrenHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "setChildrenHeight", function () {
      var childrens = _toConsumableArray(_this.state.childrenRef.children);

      var childrenHeight = childrens.reduce(function (prev, curr) {
        return prev + curr.offsetHeight;
      }, 0);

      _this.setState({
        childrenHeight: childrenHeight
      });
    });

    return _this;
  }

  _createClass(UTCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          header = _this$props.header,
          footer = _this$props.footer,
          children = _this$props.children,
          horizontal = _this$props.horizontal,
          className = _this$props.className,
          isCollapsible = _this$props.isCollapsible,
          style = _this$props.style,
          classes = _this$props.classes,
          isOpen = _this$props.isOpen,
          flat = _this$props.flat,
          button = _this$props.button,
          expandableContentClassName = _this$props.expandableContentClassName,
          expandableIconClassName = _this$props.expandableIconClassName,
          expandableIconButtonClassName = _this$props.expandableIconButtonClassName,
          headerClassName = _this$props.headerClassName,
          CustomFooter = _this$props.CustomFooter;
      var _this$state = this.state,
          expandIsSelected = _this$state.expandIsSelected,
          childrenHeight = _this$state.childrenHeight;
      var expanded = isOpen !== null ? isOpen : expandIsSelected;
      return !isCollapsible ? _react["default"].createElement("div", {
        className: "".concat(classes.base, " ").concat(flat && classes.flat, " ").concat(!horizontal && _stylesModule["default"].column, " ").concat(className),
        style: style
      }, header && _react["default"].createElement("div", {
        className: _stylesModule["default"].headerContent
      }, header), children, CustomFooter ? _react["default"].createElement(CustomFooter, null) : footer && _react["default"].createElement(_UTCardFooter["default"], {
        customButton: button,
        footer: footer
      })) : _react["default"].createElement("div", {
        className: "".concat(classes.base, " ").concat(flat && classes.flat, " ").concat(_stylesModule["default"].column, " ").concat(className),
        style: style
      }, _react["default"].createElement(_UTTouchableWithoutFeedback["default"], {
        onClick: this.handleOnPress,
        className: "".concat(_stylesModule["default"].header, " ").concat(headerClassName)
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].headerContent
      }, header), _react["default"].createElement(_IconButton["default"], {
        onClick: this.handleOnPress,
        className: expandableIconButtonClassName
      }, expanded ? _react["default"].createElement(_ExpandLess["default"], {
        className: expandableIconClassName
      }) : _react["default"].createElement(_ExpandMore["default"], {
        className: expandableIconClassName
      }))), _react["default"].createElement("div", {
        ref: function ref(_ref) {
          return _this2.setState({
            childrenRef: _ref
          });
        },
        className: "".concat(_stylesModule["default"].children, " ").concat(expanded && _stylesModule["default"].active, " ").concat(expandableContentClassName),
        style: {
          height: expanded && childrenHeight !== null ? childrenHeight : '0px'
        }
      }, children), CustomFooter ? _react["default"].createElement(CustomFooter, null) : footer && _react["default"].createElement(_UTCardFooter["default"], {
        customButton: button,
        footer: footer
      }));
    }
  }]);

  return UTCard;
}(_react.PureComponent);

UTCard.propTypes = {
  header: _types.cardActionsTypes.header,
  footer: _types.cardActionsTypes.footer,
  horizontal: _propTypes.bool,
  className: _propTypes.string,
  isCollapsible: _propTypes.bool,
  onClick: _propTypes.func,
  classes: (0, _propTypes.shape)(_propTypes.any),
  isOpen: _propTypes.bool,
  style: (0, _propTypes.shape)(_propTypes.any),
  flat: _propTypes.bool,
  button: _propTypes.element,
  expandableContentClassName: _propTypes.string,
  expandableIconClassName: _propTypes.string,
  expandableIconButtonClassName: _propTypes.string,
  headerClassName: _propTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  CustomFooter: _propTypes.any
};
UTCard.defaultProps = {
  isOpen: null,
  style: {}
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(UTCard);

exports["default"] = _default;